import React from 'react';
import { Link } from 'react-router-dom';
import './MenuSocials.css';

const MenuSocials = (props) => {
    return ( 
        <>
        <Link><img className='menuSocial' src={props.menuSocial} alt={props.menuSocialAlt} />
        </Link>
        </>
     );
}
 
export default MenuSocials;